import { ImHtmlFive2 } from 'react-icons/im'

export const HTMLTech = () => {
    return (
        <div>
        <ImHtmlFive2 />
        <h4>HTML 5</h4>
        </div>
    )
}